/* eslint max-len: ["error", { "code": 120, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import * as types from '../constants/ActionTypes';
import {Utils} from '../components/Utils';
import {env} from '../constants/env';

Utils.init('actions');

export const getTelomere = (age, sex, length) => ({
    type: types.REQUEST_TELOMERE,
    age,
    sex,
    length,
});

export const receiveTelomere = (telomere) => ({
    type: types.RECEIVE_TELOMERE,
    telomere,
});

export const errorTelomere = (errorCode) => ({
    type: types.ERROR_TELOMERE,
    errorCode,
});

export const resetErrorTelomere = () => ({
    type: types.RESET_ERROR_TELOMERE,
});

export function apiTelomereAge(age, sex, length) {
    return function(dispatch, getState) {
        dispatch(getTelomere(age, sex, length));

        Utils.log('actions', 'apiTelomereAge');

        let dataURL = env.apiUrl + '/telomeresApi/v1/getTelomereAgeImage?username=' + getState().login.username +
                                        '&age=' + age +
                                        '&sex=' + (sex === 0? 'm' : 'f') +
                                        '&length=' + length +
                                        '&token=' + getState().login.token;
        // return fetch(dataURL, {headers: new Headers({'Access-Control-Allow-Origin': '*'})})
        return fetch(dataURL)
            .then(
                (response) => response.json(),
                (error) => {
                    throw new TypeError(error);
                }
            )
            .then((telomere) => {
                if (telomere.length === undefined) {
                    dispatch(errorTelomere(telomere.code));
                } else {
                    dispatch(receiveTelomere(telomere));
                }
            })
            .catch((error) => {
                    Utils.errobj('ACTIONS', 'apiTelomereAge', error);
                    dispatch(errorTelomere(500));
                }
            );
    };
}



// WEBPACK FOOTER //
// ./src/actions/telomere.js